import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { NodeWithI18n, TextAst } from '@angular/compiler';
import { noUndefined } from '@angular/compiler/src/util';



@Component({
  selector: 'app-student-setting-page',
  templateUrl: './student-setting-page.component.html',
  styleUrls: ['./student-setting-page.component.scss']
})
export class StudentSettingPageComponent implements OnInit, AfterViewInit {
  panelOpenState = false;
  Arr= [
    {name: 'Fax', display: '', Require: true, Visible: true},
    {name: 'Address', display: '', Require: false, Visible: true},
    {name: 'Email', display: '', Require: true, Visible: true},
    
  ];
  PersonalDetail= [
    {name: 'First Name', display: '', Require: false, Visible: true},
    {name: 'Middle Name', display: '', Require: false, Visible: true},
    {name: 'Last Name', display: '', Require: false, Visible: true},
    {name: 'Full Name', display: '', Require: false, Visible: true},
    {name: 'Gender', display: '', Require: false, Visible: true},
    {name: 'Date of Birth', display: '', Require: true, Visible: true},
    {name: 'Age', display: '', Require: false, Visible: true},
    {name: 'Birth Place', display: '', Require: true, Visible: true},
    {name: 'Marital Status', display: '', Require: true, Visible: true},
    {name: 'Blood Group', display: '', Require: true, Visible: true},
    {name: 'Mother Tongue', display: '', Require: false, Visible: true},
    {name: 'Reg. No. / PR No.', display: '', Require: true, Visible: true},
    {name: 'Registration Year', display: '', Require: true, Visible: true},
    {name: 'Mobile Number', display: '', Require: false, Visible: true},
    {name: 'WhatsApp Number', display: '', Require: true, Visible: true},
    {name: 'Email ID', display: '', Require: true, Visible: true},
    {name: 'Email Belongs To', display: '', Require: true, Visible: true},
    {name: 'BPL Category', display: '', Require: true, Visible: true}
  ];
  ContactDetail= [
    {name: 'Nationality', display: '', Require: true, Visible: true},
    {name: 'Domicile', display: '', Require: false, Visible: true},
    {name: 'Religion', display: '', Require: true, Visible: true},
    {name: 'Correspondance Address', display: '', Require: false, Visible: true},
    {name: 'Country', display: '', Require: false, Visible: true},
    {name: 'State', display: '', Require: false, Visible: true},
    {name: 'District', display: '', Require: false, Visible: true},
    {name: 'Tehsil', display: '', Require: false, Visible: true},
    {name: 'City/Village/Area/Ward', display: '', Require: false, Visible: true},
    {name: 'Pincode', display: '', Require: false, Visible: true},
    {name: 'Permanent Address', display:'', Require: false, Visible: true},
    {name: 'Same as Correspondance', display:'', Require: false, Visible: true},
    {name: 'Country(Permanent Addr)', display:'', Require: false, Visible: true},
    {name: 'State(Permanent Addr)', display: '', Require: false, Visible: true},
    {name: 'District(Permanent Addr)', display: '', Require: false, Visible: true},
    {name: 'Tehsil(Permanent Addr)', display: '', Require: false, Visible: true},
    {name: 'City/Village/Area/Ward(Permanent Addr)', display: '', Require: false, Visible: true},
    {name: 'Pincode(Permanent Addr)', display:'', Require: false, Visible: true} 
    
  ];
  RegisterDetail= [
    {name: 'Religion', display: '', Require: false, Visible: true},
    {name: 'Social Category', display: '', Require: true, Visible: true},
    {name: 'Caste', display: '', Require: false, Visible: true},
    {name: 'Caste Certificates', display: '', Require: false, Visible: true},
    {name: 'Caste Validity Certficate', display: '', Require: false, Visible: true},
    {name: 'Non-creamy Layer Certificate', display: '', Require: false, Visible: true},
    {name: 'Non-creamy Layer Validity Date', display: '', Require: false, Visible: true},
    {name: 'Are You Applying For In House Quota?', display: '', Require: false, Visible: true},
    {name: 'Do You Belong To Any Minority', display: '', Require: false, Visible: true},
    {name: 'Select Minority Type', display: '', Require: false, Visible: true},
    {name: 'Minority', display: '', Require: true, Visible: true},
    {name: 'Specially Abled?', display: '', Require: true, Visible: true},
    {name: 'Select Specially Abled Type', display: '', Require: true, Visible: true},
    {name: 'Are You Orphan?', display: '', Require: true, Visible: true},
    {name: 'Orphan Type?', display: '', Require: true, Visible: true},
    {name: 'Ex-Servicemen (Def-1)', display: '', Require: true, Visible: true},
    {name: 'Active Domicile Defence Candidates.(Def-2)', display: '', Require: true, Visible: true},
    {name: 'Active Non Domicile Defence Candidates.(Def-3)', display: '', Require: true, Visible: true},
    
  ];
  QualificationDetail=[
    {name: 'Course Level', display: '', Require: true, Visible: true},
    {name: 'Course Name', display: '', Require: false, Visible: true},
    {name: 'Result Status', display: '', Require: true, Visible: true},
    {name: 'Board / University', display: '', Require: true, Visible: true},
    {name: 'College / School Name', display: '', Require: false, Visible: true},
    {name: 'Year Of Passing', display: '', Require: true, Visible: true},
    {name: 'Mark List Registration No.', display: '', Require: true, Visible: true},
    {name: 'Seat Number', display: '', Require: false, Visible: true},
    {name: 'Obtained Marks', display: '', Require: true, Visible: true},
    {name: 'Total Marks', display: '', Require: true, Visible: true},
    {name: 'Percentage', display: '', Require: false, Visible: true},
    {name: 'Grade', display: '', Require: true, Visible: true},
    {name: 'CGPI', display: '', Require: true, Visible: true},
    {name: 'Class / Division', display: '', Require: false, Visible: true},
    {name: 'Place', display: '', Require: true, Visible: true},
  ];
  AdditionalDetail=[
    {name: 'Voter Id', display: '', Require: true, Visible: true},
    {name: 'Aadhaar Number', display: '', Require: false, Visible: true},
    {name: 'PAN Number', display: '', Require: true, Visible: true},
    {name: 'Passport Number', display: '', Require: true, Visible: true},
    {name: 'Passport Valid From', display: '', Require: false, Visible: true},
    {name: 'Passport Valid Till', display: '', Require: true, Visible: true},
    {name: 'Donate Organ?', display: '', Require: true, Visible: true},
    {name: 'Hostel Accommodation?', display: '', Require: false, Visible: true},
    {name: 'Driving License Number', display: '', Require: true, Visible: true},
    {name: 'Family Income', display: '', Require: true, Visible: true},
  ];
  PhotoSign=[
    {name: 'Upload Signature :', display: '', Require: true, Visible: true},
    {name: 'Upload Photo', display: '', Require: false, Visible: true},
  ];
  AdmissionDetail=[
    {name: 'Study Mode', display: '', Require: true, Visible: true},
    {name: 'Course Level', display: '', Require: false, Visible: true},
    {name: 'Student Type', display: '', Require: true, Visible: true},
    {name: 'Faculty', display: '', Require: true, Visible: true},
    {name: 'Course', display: '', Require: false, Visible: true},
    {name: 'Branch - Pattern', display: '', Require: true, Visible: true},
    {name: 'Exam', display: '', Require: true, Visible: true},
    {name: 'College', display: '', Require: false, Visible: true},
    {name: 'Examination Center', display: '', Require: true, Visible: true},
    {name: 'Received SLM From', display: '', Require: true, Visible: true},
    {name: 'Special Category', display: '', Require: false, Visible: true},
  ];
  Document=[
    {name: 'Social Category', display: '', Require: true, Visible: true},
    {name: 'Caste', display: '', Require: false, Visible: true},
    {name: 'Minority', display: '', Require: true, Visible: true},
  ];


  StudentEdit: FormGroup;
  
  ss: any[];
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder, 
    public router: Router,
    private dialog: MatDialog,
    ) {
      // this.dataSource2.data = TREE_DATA;  
    }
    // hasChild = (_: number, node: FoodNode) => !!node.Arr && node.Arr.length >= 0;
  
  arr1:any = [];
  aar: any = [];
  StudentArr: any = [];
  adminArr: any = [];
  ngOnInit(): void {
    let id = '';
    // this.check = false;
    this.StudentEdit = this.fb.group({
      FormName: new FormControl ('', [Validators.required]),
        FormRequired: new FormControl (''),
        FormVisible: new FormControl (''),
        FormDisplayName: new FormControl ('', [Validators.required]),
        FormPattern: new FormControl ('', [Validators.required]),
        FormControlName: new FormControl ('', [Validators.required]),
        FormType: new FormControl('', [Validators.required]),
        FormPage: new FormControl('', [Validators.required]),
        IsDefault: new FormControl('', [Validators.required]),
    
    });

    this.getData(id);
    
  }

  ngAfterViewInit(): void{
    
  }


  getData(id){
    const payload = {};
    payload['FormRequired'] = id;
    payload['FormVisible'] = id;
    payload['FormPage'] = id;
    payload['IsDefault'] = 'true';
      this.umsService.getStdSetting(payload).subscribe(res => {
        let data = res.data
        this.adminArr = data;
        this.adminArr.forEach(element => {
            // if((element.FormVisible== true) && (element.IsDefault==true)){
            //   this.Arr.push({name:element.FormName,Require:element.Require,Visible:element.FormVisible,display:element.display});
            // }
            if((element.FormVisible==true) && (element.FormPage == 'PersonalDetails')){
              this.PersonalDetail.push({name:element.FormName,Require:element.FormRequired,Visible:element.FormVisible,display:element.FormDisplayName});
            }
            else if((element.FormVisible==true) && (element.FormPage == 'ContactDetails')){
              this.ContactDetail.push({name:element.FormName,Require:element.FormRequired,Visible:element.FormVisible,display:element.FormDisplayName});
              
            }
            else if((element.FormVisible==true) && (element.FormPage == 'ReserveDetails')){
              this.RegisterDetail.push({name:element.FormName,Require:element.FormRequired,Visible:element.FormVisible,display:element.FormDisplayName});
      
            }
            else if((element.FormVisible==true) && (element.FormPage == 'QualifyDetails')){
              this.QualificationDetail.push({name:element.FormName,Require:element.FormRequired,Visible:element.FormVisible,display:element.FormDisplayName});
            }
            else if((element.FormVisible==true) && (element.FormPage == 'AdditionalDetail')){
              this.AdditionalDetail.push({name:element.FormName,Require:element.FormRequired,Visible:element.FormVisible,display:element.FormDisplayName});
            }
            else if((element.FormVisible==true) && (element.FormPage == 'PhotoSign')){
              this.PhotoSign.push({name:element.FormName,Require:element.FormRequired,Visible:element.FormVisible,display:element.FormDisplayName});
            }
            else if((element.FormVisible==true) && (element.FormPage == 'AdmDetails')){
              this.AdmissionDetail.push({name:element.FormName,Require:element.FormRequired,Visible:element.FormVisible,display:element.FormDisplayName});
            }
          })
        
      });
   
  }

  add(event, e){
   let payload = this.StudentEdit.value;
    if(event.value=='Yes'){
      this.StudentArr.push({name:e.name,Require:payload.FormRequired,Visible:payload.FormVisible,display:payload.FormDisplayName});
      this.arr1 = JSON.stringify(this.StudentArr)
    }
    else if(event.pdetail=='Yes'){
      this.StudentArr.push({name:e.name,
        Require:payload.FormRequired,
        Visible:payload.FormVisible,
        display:payload.FormDisplayName,});
    }
    else if(event.cdetail=='Yes'){
      this.StudentArr.push({name:e.name,Require:payload.SRequire,Visible:payload.SVisible,display:payload.Sdisplay});
      this.arr1 = JSON.stringify(this.StudentArr);
    }
    else if(event.regdetail=='Yes'){
      this.StudentArr.push({name:e.name,Require:payload.SRequire,Visible:payload.SVisible,display:payload.Sdisplay});
      this.arr1 = JSON.stringify(this.StudentArr);
    }
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  next(){
    this.redirect('student-form');
  }
  Regnext(){
    this.redirect('student-registration-tab');
  }

  update(id){
    let payload = this.StudentEdit.value;
    payload['FormName'] = id;
    payload['FormDisplayName'] = id;
    payload['FormRequired'] = id;
    payload['FormVisible'] = id;
    payload['FormControlName'] = id;
    payload['FormPattern'] = id;
    payload['FormType'] = id;
    payload['FormPage'] = id;
    payload['IsDefault'] = id;
    // this.StudentArr.push({FormName:payload.FormName,
    //   FormRequired:payload.FormRequired,
    //   FormVisible:payload.FormVisible,
    //   FormDisplayName:payload.FormDisplayName,
    // });
    this.StudentArr.forEach(element => {
      this.umsService.updateStdSetting(element).subscribe(res => {
        let data = res.data
      });
    });
  }
  
  save1(){
    // sessionStorage.setItem('arr1',this.arr1);
    let id = '';
   this.update(id);
  }

  save(){

  }



 
}
